import type { OAuthFetchers, TokenResponse } from "./types";

export class AuthRequestError extends Error {
  readonly status: number;

  constructor(status: number, url: string) {
    super(`auth request failed (${status}) for ${url}`);
    this.name = "AuthRequestError";
    this.status = status;
  }
}

async function postForm(
  url: string,
  fields: Record<string, string>,
): Promise<TokenResponse> {
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(fields).toString(),
  });
  if (!response.ok) {
    throw new AuthRequestError(response.status, url);
  }
  return (await response.json()) as TokenResponse;
}

// Raw fetch, deliberately NOT the axios instance: keeps token exchange/refresh
// out of the 401 interceptor and prevents refresh recursion.
export function createFetchers(): OAuthFetchers {
  return {
    exchangeCode: ({ tokenUrl, code, redirectUri, clientId }) =>
      postForm(tokenUrl, {
        grant_type: "authorization_code",
        code,
        redirect_uri: redirectUri,
        client_id: clientId,
      }),
    refresh: ({ tokenUrl, refreshToken, clientId }) =>
      postForm(tokenUrl, {
        grant_type: "refresh_token",
        refresh_token: refreshToken,
        client_id: clientId,
      }),
  };
}
